<template>
  <Skeleton :menu-fix="menuFix">
    <template v-slot:nav>
      <Nav :items="nav.items" :menus="menu.items" />
    </template>
    <router-view />
  </Skeleton>
</template>

<script>
import Skeleton from "@/components/Skeleton/index.vue";
import Menu from "@/components/Menu/index.vue";
import Nav from "@/components/Nav/index.vue";
import perferenceMenu from "@/config/perferenceMenu.js";
import theNav from "@/config/nav.js";

export default {
  props: {
    menuFix: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      menu: perferenceMenu,
      nav: theNav,
    };
  },

  components: {
    Skeleton,
    Menu,
    Nav,
  },
};
</script>
